export default "__VITE_ASSET__6YlvPY8r__"